export const paiRoutes = (apiBase) => ({
  paiRegistro: `${apiBase}/pai/registro`,
  paiReporte: `${apiBase}/pai/reporte/descargar`,
  paiConfigVacunas: `${apiBase}/pai/config/vacunas`,
  paiConfigSecciones: `${apiBase}/pai/config/secciones`,
  paiConfigCatalogos: `${apiBase}/pai/config/catalogos`,
  elementos: (form = 'pai', label = '') => `${apiBase}/elementos?form=${form}${label ? `&label=${label}` : ''}`,
  paiPaciente: (identificacion) => `${apiBase}/pai/paciente?identificacion=${identificacion}`,
  paiUpdateEsquemaVacunacion: `${apiBase}/pai/esquema-vacunacion`,
  paiUpdateHistorial: `${apiBase}/pai/historial/actualizar`,
});
